// export const BASE_URL = "http://18.159.82.242:9071/api/v1";
// export const BASE_URL = "http://18.159.82.242/v1";
export const BASE_URL = "https://api.tor.digital/v1";
// export const BASE_URL = "http://15.207.186.243:3100/v1";